import { AxiosRequestConfig } from "axios";
import { requests } from "../config";
import { ISellerReqData } from "./models/reqests";
import { ISellerTableDataItem, OrderDetail } from "./models/tableData";
import { ITransportationCompany } from "./models/transportation";

export const SELLER = {
  getSellerPGC: (data: string): Promise<ISellerTableDataItem> => requests.get(`seller/supply_details_by_products?Date=${data}`, 'go'),
  postOrder: (data: ISellerReqData, config?: AxiosRequestConfig): Promise<OrderDetail> => requests.post("/order/detail", "go", data),
  putOrder: (data: ISellerReqData, config?: AxiosRequestConfig): Promise<OrderDetail> => requests.put(`/order/detail/${data.RecID}`, "go", data),
  getTransportation: (data: string): Promise<ITransportationCompany[]> => requests.get(`seller/supply_details_by_frcompanies?Date=${data}`, "go"),
}